import { useQuery, ApolloQueryResult } from '@apollo/client';
import { capitalize } from 'lodash';
import React from 'react';
import {
  CommerceAddress,
  FetchShipToPartiesForTransactionAccountQuery,
  FetchShipToPartiesForTransactionAccountQueryVariables,
} from '@css-xp/graphtypes';
import {
  ColGroup,
  SearchResultsTable,
  TableBody,
  TableHead,
  OpenSidebarRow,
  BillingAddressDetailsLine,
} from '@css-xp/base';
import { SIDEBAR } from '../../../transaction-account';
import { fetchShippingAddressesForTransactionAccount } from './queries/fetch-ship-to-parties-for-transaction-account';
interface ShippingAddressesTableProps {
  transactionAccountId?: string;
  billToAddress?: CommerceAddress | null;
  refetch?: () => Promise<ApolloQueryResult<unknown>>;
}

const columns = [
  {
    name: 'Name',
    customClassNames: 'col-20',
  },
  {
    name: 'Address',
    customClassNames: 'col-30',
  },
  {
    name: 'Tax id',
    customClassNames: 'col-20',
  },
  {
    name: 'Price Eligibility',
    customClassNames: 'col-30',
  },
  {
    name: '',
  },
];

const ShipToPartiesTable = ({ transactionAccountId, billToAddress, refetch }: ShippingAddressesTableProps) => {
  const { data, loading, error } = useQuery<
    FetchShipToPartiesForTransactionAccountQuery,
    FetchShipToPartiesForTransactionAccountQueryVariables
  >(fetchShippingAddressesForTransactionAccount, {
    variables: {
      id: transactionAccountId ?? '',
    },
    skip: !transactionAccountId,
  });

  const hasNoResults = !loading && (!data || data?.transactionAccount.availableShipToParties?.totalCount === 0);
  const shipToParties = data?.transactionAccount.availableShipToParties?.nodes;

  return (
    <SearchResultsTable
      id="ship-to-parties"
      isLoading={loading}
      error={error?.toString()}
      noResults={hasNoResults}
      heading={'Ship to parties'}
      entityName="ship to parties"
    >
      <ColGroup columns={columns} />
      <TableHead columns={columns} />
      <TableBody>
        {(shipToParties ?? []).map((shipToParty, index) => {
          return (
            <React.Fragment key={`search-result-${index}`}>
              <OpenSidebarRow
                sidebar={SIDEBAR.EDIT_SHIP_TO_PARTY}
                payload={{
                  shipToAddress: shipToParty,
                  transactionAccountId,
                  billToAddress,
                  pricingEligibility: shipToParty?.shipToPriceEligibility,
                  refetch,
                }}
                isSelected={false}
              >
                <td>
                  {/* <AddressIcon className="avatar medium not-round" /> */}
                  {shipToParty?.name}
                </td>
                <td>
                  <BillingAddressDetailsLine address={shipToParty} shouldDisplayName={false} />
                </td>
                <td>{shipToParty?.taxId}</td>
                <td>{shipToParty?.shipToPriceEligibility && capitalize(shipToParty?.shipToPriceEligibility)}</td>
                <td />
              </OpenSidebarRow>
            </React.Fragment>
          );
        })}
      </TableBody>
    </SearchResultsTable>
  );
};

export default ShipToPartiesTable;
